(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/iam-iframe-eid-app-handler.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/iam-iframe-eid-app-handler.js');

'use strict';

if (svs.accountservices.check_iam.isIamIFrameEnabled) {
  const updateQuerystringWithParams = (entriesObj, options) => {
    const url = new URL(window.location.href);
    Object.entries(entriesObj || {}).forEach(_ref => {
      let [key, value] = _ref;
      if (value === undefined || value === null || value === '') {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, String(value));
      }
    });
    const state = {
      v: Date.now()
    };
    if (options && options.commit === 'push') {
      window.history.pushState(state, '', url.toString());
    } else {
      window.history.replaceState(state, '', url.toString());
    }
  };

  const isStandaloneSafari = userAgent => userAgent.indexOf('safari') > -1 && userAgent.indexOf('version/') > -1;

  const handleIOS = () => {
    var _navigator, _svs;
    const userAgent = ((_navigator = navigator) === null || _navigator === void 0 || (_navigator = _navigator.userAgent) === null || _navigator === void 0 ? void 0 : _navigator.toLowerCase()) || '';
    const isNativeApp = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.isNativeApp;
    if (isNativeApp) {
      return encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutiken.bankid'));
    } else if (userAgent.indexOf('firefox') > -1 || userAgent.indexOf('fxios') > -1) {
      return encodeURIComponent('firefox://');
    } else if (userAgent.indexOf('edgios') > -1 || userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg/') > -1) {
      if (window.location.protocol.indexOf('s') > -1) {
        return 'microsoft-edge-https://';
      }
      return 'microsoft-edge-http://';
    } else if (isStandaloneSafari(userAgent)) {
      return encodeURIComponent(svs.utils.url.currentUrlEncodedParams());
    }
    return 'null'; 
  };

  const getReturnUrlForEidApp = function (serializedLoginObject) {
    let isBankId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let returnUrl;
    updateQuerystringWithParams({
      iif: true,
      isBankId,
      slo: serializedLoginObject
    }, {
      commit: 'push'
    });
    if (svs.core.detect.browser.crios()) {
      if (window.location.protocol.indexOf('s') > -1) {
        returnUrl = 'googlechromes://';
      } else {
        returnUrl = 'googlechrome://';
      }
    } else if (svs.core.detect.os.iOS()) {
      returnUrl = handleIOS();
    } else {
      returnUrl = 'null';
    }
    return returnUrl;
  };
  svs.playerLoginReact.sharedComponents.iamIframeEidAppHandler = {
    getReturnUrlForEidApp
  };
}

 })(window);